import React from 'react'
import { t } from 'src/lib/i18n-react'

import Svg1 from './assets/1'
import Svg2 from './assets/2'
import Svg3 from './assets/3'
import Svg4 from './assets/4'
import Svg5 from './assets/5'
import Svg6 from './assets/6'
import Svg7 from './assets/7'
import Svg8 from './assets/8'
import Svg9 from './assets/9'

export enum OnboardingReason {
  fun = 'fun',
  travel = 'travel',
  family = 'family',
  work = 'work',
  dailyLife = 'daily_life',
  cert = 'certification',
  school = 'school',
  selfImprovement = 'self_improvement',
  other = 'other',
}

export type LearningReason = {
  id: number
  answerText: string
  icon: JSX.Element
  answerName: OnboardingReason
  question: OnboardingQuestion.reason
}

export enum OnboardingQuestion {
  reason = 'language_learning_reason',
}

const reasons: LearningReason[] = [
  {
    id: 1,
    answerText: t('Just for fun'),
    icon: <Svg1 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.fun,
    question: OnboardingQuestion.reason,
  },
  {
    id: 2,
    answerText: t('For travel'),
    icon: <Svg2 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.travel,
    question: OnboardingQuestion.reason,
  },
  {
    id: 3,
    answerText: t('For my partner and family'),
    icon: <Svg3 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.family,
    question: OnboardingQuestion.reason,
  },
  {
    id: 4,
    answerText: t('For professional reasons'),
    icon: <Svg4 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.work,
    question: OnboardingQuestion.reason,
  },
  {
    id: 5,
    answerText: t('For daily life'),
    icon: <Svg5 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.dailyLife,
    question: OnboardingQuestion.reason,
  },
  {
    id: 6,
    answerText: t('For citizenship or certification'),
    icon: <Svg6 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.cert,
    question: OnboardingQuestion.reason,
  },
  {
    id: 7,
    answerText: t('For school'),
    icon: <Svg7 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.school,
    question: OnboardingQuestion.reason,
  },
  {
    id: 8,
    answerText: t('For self-improvement'),
    icon: <Svg8 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.selfImprovement,
    question: OnboardingQuestion.reason,
  },
  {
    id: 9,
    answerText: t('Other'),
    icon: <Svg9 className="survey-icon" aria-hidden="true" />,
    answerName: OnboardingReason.other,
    question: OnboardingQuestion.reason,
  },
]

export default reasons
